import type { SalesManager } from '../api';

const MONGO_ID_REGEX = /^[0-9a-f]{24}$/i;
const PG_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export interface SalesManagerFilterOption {
  label: string;
  value: string;
}

export function parseSalesManagerFilterValue(
  rawValue?: string | null,
): string | undefined {
  const value = rawValue?.trim();
  if (!value) return undefined;

  if (MONGO_ID_REGEX.test(value) || PG_UUID_REGEX.test(value)) {
    return value;
  }

  try {
    const parsed = JSON.parse(value);
    if (!Array.isArray(parsed)) return undefined;

    const validIds = parsed.filter(
      (item): item is string =>
        typeof item === 'string' && (MONGO_ID_REGEX.test(item) || PG_UUID_REGEX.test(item)),
    );

    return validIds.length === 1 ? validIds[0] : undefined;
  } catch {
    return undefined;
  }
}

export function buildSalesManagerFilterOptions(
  salesManagers: SalesManager[],
  options: {
    valueKey?: 'id' | 'mongoUserId';
    formerLabel?: string;
  } = {},
): SalesManagerFilterOption[] {
  const seen = new Set<string>();
  const filterOptions: SalesManagerFilterOption[] = [];
  const valueKey = options.valueKey ?? 'id';
  const formerLabel = options.formerLabel ?? 'Former';

  for (const manager of salesManagers) {
    const value = valueKey === 'mongoUserId' ? manager.mongoUserId : manager.id;
    if (!value || seen.has(value)) continue;
    seen.add(value);

    filterOptions.push({
      value,
      label: `${manager.name}${manager.isFormer ? ` (${formerLabel})` : ''}`,
    });
  }

  return filterOptions;
}
